<template>
	<div>
		<div class="form-row">
			<div class="form-group col-md-12">
		        <label>Produto *</label>
		        <select-two
		        	:options="produtos"
		        	:formId="name+'produto_id'"
		        	:valueDefault="dados.produto"
		        	@selected="setProdutoId"
		        	@searching="getProdutos"
		        	@noValue="setProdutoId('')"
		        	arrayValue="nome">
		        </select-two>
		        <div class="invalid-feedback" :id="name+'produto_id-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-4">
		        <label>Quantidade</label>
		        <input
		        	type="number"
		        	class="form-control"
		        	v-model="dados.quantidade"
		        	:id="name+'quantidade'"
		        	@input="clearValidation('quantidade')">
		        <div class="invalid-feedback" :id="name+'quantidade-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Valor Unidade</label>
                <money
                    :id="name+'valor'"
                    class="form-control"
                    v-model="dados.valor"
                    @input="clearValidation('valor')">
                </money>
		        <div class="invalid-feedback" :id="name+'valor-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Desconto</label>
                <money
                    :id="name+'desconto'"
                    class="form-control"
                    v-model="dados.desconto"
                    @input="clearValidation('desconto')">
                </money>
		        <div class="invalid-feedback" :id="name+'desconto-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Descrição</label>
				<vue-editor v-model="dados.descricao"></vue-editor>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados),
				produtos: []
			}
		},
		created(){
			this.getProdutos();
		},
		methods : {
			getProdutos(pesquisa=''){
				axios.get(this.$url+'/api/adm/produtos/list?pesquisa='+pesquisa)
	            .then(response => {
	                this.produtos = response.data.data
	            })
			},
			setProdutoId(valor){
				this.dados.produto_id = valor.id;
				this.dados.valor = valor.valor;
			},
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
